module.exports = __webpack_public_path__ + "img/IMG_1444_L_Wood_MockedUp.fc03d07d.jpg";